var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"display-textarea",domProps:{"innerHTML":_vm._s(_vm.sanitizedLink(_vm.content))}})
}
var staticRenderFns = []

export { render, staticRenderFns }